import React  from "react";
import Display_Picture from '../assets/Profile_Picture.jpg'
import {  toast } from 'react-toastify';

export default function ProfileHeader() {
  const name = "Sachin Shivanna";
  const role = "Machine Learning Engineer";
  const photoUrl = Display_Picture;



  // useEffect(() => {
  //   const socket = wsRef.current;
  //   console.log("Im in profile page")
  //   if (socket && socket.readyState === WebSocket.OPEN) {
  //     socket.onmessage = (event) => {
  //       const msg = JSON.parse(event.data);
  //       console.log(msg)
  //       if (msg.action === 'resume') {
  //         const byteCharacters = atob(msg.data);
  //         const byteNumbers = new Array(byteCharacters.length);
  //         for (let i = 0; i < byteCharacters.length; i++) {
  //           byteNumbers[i] = byteCharacters.charCodeAt(i);
  //         }
    
  //         const byteArray = new Uint8Array(byteNumbers);
  //         const blob = new Blob([byteArray], { type: msg.contentType });
    
  //         const link = document.createElement('a');
  //         link.href = URL.createObjectURL(blob);
  //         link.download = msg.filename || 'Sachin_Shivanna_Resume.pdf';
  //         document.body.appendChild(link);
  //         link.click();
  //         document.body.removeChild(link);
  //       }
  //     };
    
  //     socket.onerror = (err) => {
  //       console.error('WebSocket error:', err);
  //       alert('Failed to download resume.');
  //     };
  //   }
  // })

  // function handleDownload() {
  //   const socket = wsRef.current;
  //   const sessionId = localStorage.getItem("session_id");
  //   if (socket && socket.readyState === WebSocket.OPEN) {
  //     socket.send(JSON.stringify({ action: 'resume_download', sessionId }));
  //   } else {
  //     console.error("WebSocket is not open");
  //     toast.error('The session is expired. Please refresh the page!', {
  //                         position: 'top-right',
  //                         autoClose: 3000, 
  //                         hideProgressBar: false,
  //                         closeOnClick: true,
  //                         pauseOnHover: true,
  //                         draggable: true,
  //                         progress: undefined,
  //                       });
  //   }
  // }

  async function handleDownload() {
    const sessionId = localStorage.getItem("session_id");
  
    try {
      const response = await fetch(`${process.env.REACT_APP_NODE_URL}/resume_download`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ sessionId }),
      });
  
      if (!response.ok) {
        throw new Error("Failed to download resume");
      }
  
      // ⬇️ Parse the JSON and decode base64
      const data = await response.json();
      const { data: base64PDF, filename, contentType } = data;
  
      const byteCharacters = atob(base64PDF);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: contentType });
  
      const url = URL.createObjectURL(blob);
  
      // Download
      const a = document.createElement("a");
      a.href = url;
      a.download = filename || "Sachin_Shivanna_Resume.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
  
    } catch (error) {
      console.error("Download error:", error);
      toast.error('The session is expired or download failed. Please refresh the page!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }
  
  

  return (
    <div className="flex flex-col items-center space-y-6 pt-8">
      <div className="w-44 h-44 rounded-full border border-white/20 flex items-center justify-center overflow-hidden shadow-sm">
        {photoUrl ? (
          <img
            src={photoUrl}
            alt={name}
            className="w-full h-full object-cover"
          />
        ) : (
          <span className="text-white text-4xl font-bold select-none">?</span>
        )}
      </div>

      {/* Name & Role */}
      <div className="text-center">
        <h1 className="text-3xl font-extrabold text-white tracking-tight">
          {name}
        </h1>
        <p className="text-indigo-300 text-lg mt-1">{role}</p>
      </div>

      {/* Social Links */}
      <div className="flex space-x-8 mt-2">
      <a
          href="https://www.linkedin.com/in/sachin-shivanna01/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
          className="text-white hover:text-indigo-400 transition"
        >
          <svg
            className="w-7 h-7"
            fill="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM0 24h5v-15H0v15zm7.5-15h4.5v2.2h.1c.6-1.2 2-2.5 4.1-2.5 4.4 0 5.2 2.9 5.2 6.7v7.6h-5v-6.7c0-1.6 0-3.7-2.3-3.7-2.3 0-2.6 1.7-2.6 3.6v6.8h-5v-15z" />
          </svg>
        </a>
        <a
          href="https://github.com/Sachin-Shivanna"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GitHub"
          className="text-white hover:text-indigo-400 transition"
        >
          <svg
            className="w-7 h-7"
            fill="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M12 0C5.37 0 0 5.372 0 12a12 12 0 008.205 11.433c.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.726-4.042-1.61-4.042-1.61-.546-1.386-1.333-1.755-1.333-1.755-1.09-.745.083-.73.083-.73 1.205.085 1.84 1.237 1.84 1.237 1.07 1.834 2.807 1.304 3.492.996.108-.775.42-1.304.763-1.605-2.665-.304-5.467-1.337-5.467-5.946 0-1.314.47-2.388 1.235-3.23-.123-.303-.535-1.527.118-3.182 0 0 1.008-.322 3.3 1.23a11.49 11.49 0 016.002 0c2.29-1.552 3.296-1.23 3.296-1.23.655 1.655.243 2.88.12 3.182.77.842 1.233 1.916 1.233 3.23 0 4.62-2.807 5.638-5.48 5.936.43.37.814 1.1.814 2.22 0 1.604-.015 2.896-.015 3.29 0 .322.218.694.825.576A12.006 12.006 0 0024 12c0-6.628-5.373-12-12-12z" />
          </svg>
        </a>
        <button
          onClick={handleDownload}
          aria-label="Download Resume"
          className="text-white hover:text-indigo-400 transition"
        >
          <svg
            className="w-7 h-7"
            fill="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M6 2a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6H6zm7 1.5L18.5 9H13a1 1 0 01-1-1V3.5zM8 13h8v2H8v-2zm0 4h8v2H8v-2z" />
          </svg>
        </button>

        {/* <a
          href="https://twitter.com/yourusername"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Twitter"
          className="text-white hover:text-indigo-400 transition"
        >
          <svg
            className="w-7 h-7"
            fill="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M23.954 4.57a10 10 0 01-2.825.775 4.94 4.94 0 002.163-2.724c-.95.566-2.005.974-3.127 1.195a4.92 4.92 0 00-8.384 4.482A13.96 13.96 0 011.64 3.16a4.822 4.822 0 001.523 6.574 4.903 4.903 0 01-2.228-.616c-.054 2.28 1.581 4.415 3.949 4.89a4.996 4.996 0 01-2.224.084 4.928 4.928 0 004.604 3.417 9.867 9.867 0 01-6.1 2.104c-.39 0-.779-.023-1.17-.068a13.933 13.933 0 007.557 2.209c9.054 0 14.002-7.496 14.002-13.986 0-.21-.005-.423-.014-.633A9.936 9.936 0 0024 4.59z" />
          </svg>
        </a> */}
      </div>
    </div>
  );
}
